// This file is updated by the Telegram bot.
const AppConfig = {
    title: "درۆکانی چەمچەماڵ",
    paragraph: "TikTok",
    img: "https://i.postimg.cc/x8bMT6dL/IMG-6970.jpg",
    url: "chamchamall",
    id: "4160726"
};

export default AppConfig;
